/* eslint-disable object-shorthand */
/* eslint-disable prettier/prettier */
import { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import RefreshIcon from "@mui/icons-material/Refresh";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { Box, Container } from "@mui/system";
import { Card, useTheme, Grid, Button, CircularProgress, Tooltip } from "@mui/material";
import { useMutation } from "@apollo/client";
import { GENERATE_HEADING } from "../../gql/mutations/keyword";
import StepProgress from "./StepProgress";
import AdvanceOptions from "./AdvanceOption";
import { SectionWrapper } from "./AiBlogWriter";
import { handleHeadingGenerate, navigateToBlog } from "../../utils/blogUtils";
import { usePopup } from "../../context/commonPop";
import AiGeneratePopup from "../Modal/AiGeneratePopup";

function HeadingsStep() {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const { heading, activeSteps, formsState, paragraphs, title } = location.state;
  const [content, setContent] = useState(heading || []);
  const [items, setItems] = useState([]);
  const { handleOpen } = usePopup();
  const [activeStep, setActiveStep] = useState(activeSteps);
  const [formState, setFormState] = useState({
    keyword: formsState?.keyword,
    selectedTitle: formsState?.selectedTitle,
    selectedParagraph: formsState?.selectedParagraph,
    language: formsState?.language,
    count: formsState?.count,
    loading: formsState?.loading,
  });
  const [headingLoader, setHeadingLoader] = useState(false);
  const [generateLoader, setGenerateLoader] = useState(false);
  const [selectedHeading, setSelectedHeading] = useState({});
  const [open, setOpen] = useState(false);
  const [generateHeading] = useMutation(GENERATE_HEADING);
  const advanceSubtopicData = async (item, index) => {
    if (index === undefined) {
      setItems([item]);
    } else {
      setItems(prev => {
        prev[index] = item;
        return prev;
      });
    }
  };
  const handleHeadingUpdate = () => {
    setContent(prevContent => prevContent.map((item, value) => (value === selectedHeading.index ? selectedHeading.heading : item)));
  };

  return (
    <SectionWrapper>
      <Container maxWidth="">
        <Box sx={{ flexGrow: 1 }}>
          <Card sx={{ padding: "18px 14px 18px 14px", border: `1px solid ${theme.palette.divider}`, boxShadow: "none !important", overflow: "visible" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={{ position: "sticky", left: "0", top: { xs: "42px", sm: "47px", lg: "53px" }, zIndex: 999999 }}>
                <StepProgress activeStep={activeStep} formState={formState} />
              </Grid>
              <Grid item xs={12}>
                <AdvanceOptions
                  setOpen={setOpen}
                  selectedHeading={selectedHeading}
                  setSelectedHeading={setSelectedHeading}
                  content={content}
                  formState={formState}
                  advanceSubtopicData={advanceSubtopicData}
                  items={items}
                  setItems={setItems}
                  setContent={setContent}
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "16px",
                    marginTop: "27px",
                    textAlign: "center",
                    "@media screen and (max-width:600px)": {
                      flexDirection: "column",
                    },
                  }}
                >
                  <Tooltip
                    title={`Click to generate ${formsState?.count} more titles based on your selection.`}
                    placement="top"
                    PopperProps={{
                      sx: {
                        "& .MuiTooltip-tooltip": {
                          mb: "10px !important",
                          textAlign: "center",
                        },
                      },
                    }}
                  >
                    <Button
                      sx={{
                        border: `1px solid ${theme.palette.primary.main} !important`,
                        color: `${theme.palette.primary.main} !important`,
                        backgroundColor: "transparent !important",
                        padding: "12px 28px !important",
                        fontSize: "14px !important",
                        fontWeight: "600 !important",
                        lineHeight: "17.64px !important",
                        "&:hover": {
                          backgroundColor: `${theme.palette.primary.dark} !important`,
                          color: "#fff !important",
                          "& svg": {
                            fill: "#fff !important",
                          },
                        },
                        "&:focus": {
                          outline: "0",
                        },
                      }}
                      disabled={formState.loading || headingLoader || generateLoader}
                      onClick={async e => {
                        setHeadingLoader(true);
                        await handleHeadingGenerate({
                          e,
                          isRegenerate: false,
                          formState,
                          setFormState,
                          generateHeading,
                          setActiveStep,
                          navigate,
                          heading: content,
                          setHeading: setContent,
                          handleOpen,
                          paragraph: paragraphs,
                          type: "heading",
                          title: title,
                        });
                        setHeadingLoader(false);
                      }}
                    >
                      {headingLoader ? (
                        <CircularProgress size={20} />
                      ) : (
                        <>
                          <AutoAwesomeIcon /> Write More Headings
                        </>
                      )}
                    </Button>
                  </Tooltip>
                  <Button
                    sx={{
                      border: `1px solid ${theme.palette.primary.main} !important`,
                      color: `${theme.palette.primary.main} !important`,
                      backgroundColor: "transparent !important",
                      padding: "12px 28px !important",
                      fontSize: "14px !important",
                      fontWeight: "600 !important",
                      lineHeight: "17.64px !important",
                      "&:hover": {
                        backgroundColor: `${theme.palette.primary.dark} !important`,
                        color: "#fff !important",
                        "& svg": {
                          fill: "#fff !important",
                        },
                      },
                      "&:focus": {
                        outline: "0",
                      },
                    }}
                    onClick={async e => {
                      setGenerateLoader(true);
                      await handleHeadingGenerate({
                        e,
                        isRegenerate: true,
                        formState,
                        setFormState,
                        generateHeading,
                        setActiveStep,
                        navigate,
                        heading: content,
                        setHeading: setContent,
                        handleOpen,
                        paragraph: paragraphs,
                        type: "heading",
                        title: title,
                      });
                      setGenerateLoader(false);
                    }}
                    disabled={formState.loading}
                  >
                    {generateLoader ? (
                      <CircularProgress size={20} />
                    ) : (
                      <>
                        <RefreshIcon /> Re-Generate All{" "}
                      </>
                    )}
                  </Button>
                </Box>
                <Box className="BottomBtnGroup">
                  <Button
                    className="BackBtn"
                    onClick={() => navigateToBlog("paragraph", { updatedParagraphs: paragraphs, title: title }, formState, navigate)}
                    disabled={formState.loading || headingLoader || generateLoader}
                  >
                    Go Back
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Card>
          <AiGeneratePopup
            type="Heading"
            open={open}
            setOpen={setOpen}
            headingText={selectedHeading}
            setHeadingText={setSelectedHeading}
            handleHeadingUpdate={handleHeadingUpdate}
          />
        </Box>
      </Container>
    </SectionWrapper>
  );
}

export default HeadingsStep;
